import { useBreadcrumbs } from '@shared/lib';
import { useEffect } from 'react';
import { VacancyBreadcrumbs } from '@features/vacancy';
import { WithFallback } from '@shared/ui';
import { useGetVacancy } from '@entities/vacancy';
import { useParams } from 'react-router';

import { VacancyInfo } from './components/VacancyInfo';

export const VacancyPage = () => {
  const { id } = useParams();

  const { data: vacancy, isLoading: isVacancyLoading } = useGetVacancy({
    id: Number(id),
  });

  const context = useBreadcrumbs();

  useEffect(() => {
    if (!context || !vacancy?.name) {
      return;
    }

    context.setBreadcrumb(<VacancyBreadcrumbs subPage={vacancy?.name || ''} />);

    return () => {
      context.clearBreadcrumb();
    };
  }, [vacancy?.name]);

  return (
    <WithFallback data={vacancy} isLoading={isVacancyLoading}>
      {vacancy => <VacancyInfo vacancy={vacancy} vacancyId={vacancy.id} />}
    </WithFallback>
  );
};
